import React, { useContext } from 'react';
import { bool } from 'prop-types';
import { Quantity } from '@thd-olt-component-react/quantity';
import className from 'classnames';
import { ProductPodContext } from '../../ProductPodContext';
import './ProductQuantity.style.scss';

export const ProductQuantity = (props) => {
  const {
    onQuantityChange,
    quantity: editableQuantity,
    podType,
    staticQuantity
  } = useContext(ProductPodContext);
  const quantity = staticQuantity || editableQuantity;
  const {
    showQtyText, textOnly, wideView, shortHeight, smallText, noRightMargin, showQtyValueText
  } = props;

  const wrapperClassNames = className(
    'quantity-box__wrapper',
    {
      'quantity-box__list-wrapper': podType === 'list'
    }
  );

  const inputWrapperClassNames = className(
    'quantity-box__input-wrapper',
    {
      'quantity-box__list-input-wrapper': podType === 'list'
    }
  );

  return ((showQtyText ? (
    <div data-testid="quantity-box-wrapper" className={wrapperClassNames}>
      <div className="quantity-box-text">
        Qty: { showQtyValueText && quantity }
      </div>
      {
        !showQtyValueText && (
          <div className={inputWrapperClassNames}>
            <Quantity
              value={quantity}
              onChange={onQuantityChange}
              textOnly={textOnly}
              wideView={wideView}
              smallText={smallText}
              shortHeight={shortHeight}
              noRightMargin={noRightMargin}
            />
          </div>
        )
      }
    </div>
  ) : (
    <div data-testid="quantity-box-wrapper">
      <Quantity value={quantity} onChange={onQuantityChange} textOnly={textOnly} wideView={wideView} />
    </div>
  ))
  );
};

ProductQuantity.propTypes = {
  showQtyText: bool,
  showQtyValueText: bool,
  textOnly: bool,
  wideView: bool,
  shortHeight: bool,
  smallText: bool,
  noRightMargin: bool
};

ProductQuantity.defaultProps = {
  showQtyText: false,
  showQtyValueText: false,
  textOnly: false,
  wideView: false,
  shortHeight: false,
  smallText: false,
  noRightMargin: false
};

ProductQuantity.displayName = 'ProductQuantity';
